import { usePaths } from "@engaging-tech/routing"
import React from "react"

import PromotionCard from "../../../ui/components/PromotionCard"

const Article = () => {
  const paths = usePaths()

  return (
    <PromotionCard
      title="Publish an article"
      content={[
        "Upload your own article on WorkL to educate and give to the world. Your article will be published here and on the Global Hub."
      ]}
      action={{
        description: "Publish article",
        linkTo: paths.resourceCentre.publish.article
      }}
    />
  )
}

export default Article
